export const advokatkredse = [
  { nr: 101, name: "1. kreds - Hovedstadskredsen" },
  { nr: 102, name: "2. kreds - Sjællandskredsen" },
  { nr: 103, name: "3. kreds - Syddansk kreds" },
  { nr: 104, name: "4. kreds - Østjyllands kreds" },
  { nr: 105, name: "5. kreds - Nordvestjyllands kreds" },
];
